<template>
    <!-- <div v-if="isloading">
  <LoadingComponent />
</div> -->
    <div class="row">
        <div class="col-lg-4 col-md-12">
            <Card>
                <p class="heading ms-3 mt-2 mb-1">Task Details</p>
                <hr />
                <div v-if="worksheet.length > 0">
                    <div v-for="(day, index) in worksheet" :key="index">
                        <div
                            class="day mx-3 p-2 my-2"
                            data-bs-toggle="collapse"
                            :data-bs-target="'#collapseExample' + index"
                        >
                            <div class="d-flex">
                                <div class="flex-grow-1">
                                    <p class="my-0">{{ day.day.replaceAll('_', ' ') }}</p>
                                    <p class="my-0 fade-text">Tasks : {{ day.taskList.length }}</p>
                                </div>
                                <div class="float-end align-self-center">
                                    <Badge
                                        :label="day.status.replaceAll('_', ' ')"
                                        :class="[
                                            day.status === 'COMPLETED' ? 'badge-neon badge-neon-success-outline' : '',
                                            day.status === 'IN_PROGRESS' ? 'badge-neon badge-neon-warning-outline' : '',
                                            day.status === 'NOT_YET_STARTED'
                                                ? 'badge-neon badge-neon-error-outline'
                                                : '',
                                        ]"
                                    />
                                </div>
                                <!-- <ApexChart type="radialBar" height="30" :options="chartOptions" :series="series"></ApexChart> -->
                            </div>
                        </div>
                        <div class="collapse" :id="'collapseExample' + index">
                            <div
                                class="task ms-5 me-3 p-2 my-2 d-flex justify-content-between"
                                @click="handleClick(task, day)"
                                v-for="(task, ind) in day.taskList"
                                :key="ind"
                                :title="task.task.title"
                            >
                                <p class="my-0">{{ shrinkText(task.task.title) }}</p>
                                <span class="float-end">
                                    <Badge
                                        :label="task.status ? 'COMPLETED' : 'INCOMPLETE'"
                                        :class="
                                            task.status
                                                ? 'badge-neon badge-neon-success-outline'
                                                : 'badge-neon badge-neon-error-outline'
                                        "
                                    />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <p class="fade-text mx-3">No Tasks Assigned</p>
                </div>
            </Card>
        </div>

        <div class="col-lg-8 col-md-12">
            <Card v-if="activeTask.task">
                <div>
                    <div>
                        <p class="title px-2 py-3">
                            {{ activeTask.task.title }}
                            <span class="float-end">
                                <Badge
                                    :label="activeTask.status ? 'COMPLETED' : 'INCOMPLETE'"
                                    :class="
                                        activeTask.status
                                            ? 'badge-lg badge-lg-success-solid'
                                            : 'badge-lg badge-lg-warning-solid'
                                    "
                                />
                            </span>
                        </p>
                        <div v-html="activeTask.task.description" class="mx-4 p-2 description"></div>

                        <div class="mx-2 my-1 py-2 row submission">
                            <Input
                                placeholder="Enter Your comments here...."
                                type="text"
                                class="col-12"
                                v-model="comment"
                                :disabled="activeTask.status == false ? false : !edit"
                            />
                        </div>

                        <div class="mx-3 my-2 py-2 d-flex gap-2 justify-content-end">
                            <div class="flex-grow-1 mx-1">
                                <Input
                                    placeholder="Paste Your Link Here"
                                    type="text"
                                    v-model="link"
                                    v-if="activeTask.task.submissionType === 'LINK'"
                                    :disabled="activeTask.status == false ? false : !edit"
                                />
                                <p v-if="activeTask.task.submissionType === 'LINK'" class="fade-text">
                                    link should have atleast 10 characters<sup>*</sup>
                                </p>
                            </div>
                            <div
                                class="p-2"
                                @click="toggleEdit()"
                                v-if="activeTask.status && !edit && activeTask.task.submissionType === 'LINK'"
                            >
                                <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                            </div>
                            <!-- <Button label="Add Comment" class="qb-btn qb-btn-black-md" @onClick="toggleSubmissionModal()"/> -->
                            <!-- <Button label="Add Link" class="qb-btn qb-btn-black-md" v-if="activeTask.task.submissionType === 'LINK'"/> -->

                            <div class="">
                                <Button
                                    :disabled="
                                        (activeTask.task.submissionType === 'LINK'
                                            ? link.length > 10 && (edit == true || activeTask.status != true)
                                                ? false
                                                : true
                                            : edit == true
                                            ? false
                                            : true) &&
                                        (activeTask.task.submissionType === 'LINK' || activeTask.status == true)
                                    "
                                    @onClick="updateStatus(activeTask)"
                                    :label="
                                        activeTask.task.submissionType === 'LINK' ? 'Finish Course' : 'Mark as Complete'
                                    "
                                    class="qb-btn qb-btn-primary-lg float-end"
                                ></Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
            <Card v-else>
                <div class="description-toggle">
                    <p class="title p-3">Choose a Task to view</p>
                </div>
            </Card>
        </div>

        <Modal @close="toggleSubmissionModal()" :modalActive="showSubmissionModal">
            <h4 class="my-0">Comments</h4>
            <hr class="my-1" />

            <div class="submission-body my-2">
                <div v-for="(comment, index) in comments" :key="index" class="p-2 m-2 comment-box">
                    {{ comment.name }}
                </div>
                <div class="row">
                    <Input
                        placeholder="Enter Your comments here...."
                        type="text"
                        class="col-8 mx-1"
                        v-model="comment"
                        :disabled="activeTask.status == false ? false : !edit"
                    />
                    <Button label="Add" class="qb-btn qb-btn-primary-md col-3 mx-1" />
                </div>
            </div>
            <hr class="my-1" />
        </Modal>
    </div>
</template>

<script>
import Vue from 'vue';
import Card from '../components/CardComponent.vue';
import Badge from '../components/BadgeComponent.vue';
import Button from '../components/ButtonComponent.vue';
import Input from '../components/TextFieldComponent.vue';
import Modal from '../components/ModalComponent.vue';
// import LoadingComponent from "../components/LoadingComponent.vue"
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapUserActions, mapGetters } = createNamespacedHelpers('User');
const { mapGetters: mapAuthGetters, mapActions: mapAuthActions } = createNamespacedHelpers('Auth');

export default {
    name: 'AssigneeTaskPage',
    data() {
        return {
            link: '',
            edit: false,
            comment: '',
            isloading: true,
            showSubmissionModal: false,
            comments: [{ name: 'comment 1' }, { name: 'comment 2' }, { name: 'comment 3' }],
        };
    },
    components: {
        Card,
        Badge,
        Button,
        Input,
        Modal,
        // LoadingComponent
    },
    methods: {
        ...mapUserActions({
            setActiveTask: 'SET_ACTIVE_TASK',
            setActiveDay: 'SET_ACTIVE_DAY',
            getWorksheetById: 'GET_WORKSHEET_BY_USER_ID',
            updatetaskstatus: 'UPDATE_TASK_STATUS',
        }),
        ...mapAuthActions({
            setuser: 'SET_USER',
        }),
        handleClick(task, day) {
            this.setActiveTask(task);
            this.setActiveDay(day);
            this.link = task.link;
            this.comment = task.comment;
            this.edit = false;
        },
        updateStatus(activeTask) {
            let data = {
                day: this.activeDay.day,
                link: this.link,
                comment: this.comment,
                // status: !activeTask.status,
                status: true,
                taskId: activeTask.task.id,
                userId: this.user.userId,
                id: this.user.id,
            };
            this.updatetaskstatus({
                data,
                successcallback: (res) => {
                    this.getWorksheetById(this.$route.params.workSheetId);
                    this.setActiveTask({ ...activeTask, status: true, link: data.link });
                    if (res.data.status == 'ERROR') Vue.$toast.error('An Error Occured');
                    else Vue.$toast.success(res.data.message);
                    this.link = data.link;
                    this.comment = data.comment;
                    this.edit = false;
                },
                errorcallback: (err) => {
                    console.log(err);
                    console.clear();
                },
            });
        },
        shrinkText(val) {
            if (val.length > 30) return val.slice(0, 30) + '..';
            else return val;
        },
        toggleEdit() {
            this.edit = !this.edit;
        },
        structureStatus(data) {
            return data.replaceAll('_', ' ');
        },
        toggleSubmissionModal() {
            this.showSubmissionModal = !this.showSubmissionModal;
        },
    },
    // watch:{
    //   link(val){

    //   }
    // },
    computed: {
        ...mapGetters({
            activeTask: 'getActiveTask',
            activeDay: 'getActiveDay',
            worksheet: 'getCurrentUserWorkSheetList',
        }),
        ...mapAuthGetters({
            user: 'getUser',
        }),
        calculateProgress() {
            let progress = 0;
            //let completedCount=0;
            return progress;
        },
    },
    mounted() {
        setTimeout(() => {
            this.setActiveTask({});
            this.getWorksheetById(this.$route.params.workSheetId);
            this.setuser({ ...this.user, id: this.$route.params.workSheetId });
            this.isloading = false;
        }, 1000);
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';
.day {
    // background-color: $light-fade-100;
    cursor: pointer;
    border: 1px solid $dark-fade;
    border-radius: $field-border-radius;
    font-size: $font-size-md;
    &:hover {
        background-color: rgb(244, 244, 244);
    }
}
.fa-comment-dots {
    font-size: $font-size-xxl;
}
.fa-circle-plus {
    font-size: $font-size-xxl;
    cursor: pointer;
}
.fade-text {
    color: $light-500;
    font-size: $font-size-sm;
}
// .submission-body{
//   background-color: $light-300;
//   border-radius: $field-border-radius;
// }
.comment-box {
    border: 1px solid $dark-fade;
    border-radius: $field-border-radius;
}
.task {
    cursor: pointer;
    border: 1px solid rgb(226, 226, 226);
    border-radius: $field-border-radius;
}
.task:hover {
    background-color: rgb(240, 240, 240);
}
.heading {
    font-size: $font-size-xxl;
    font-weight: $font-weight-bold;
}
.title {
    background-color: rgb(240, 240, 240);
    font-size: $font-size-xxl;
    font-weight: $font-weight-bold;
}
.description {
    height: 540px;
    max-height: 540px;
    overflow: scroll;
}
.description-toggle {
    height: 600px;
}
.submission {
    border: none;
    border-top: 1px solid rgb(226, 226, 226);
    margin-bottom: 0;
    position: sticky;
}
.fa-pen-to-square {
    cursor: pointer;
    font-size: 20px;
}
</style>
